export const DebitNoteInvoiceNumberSetting = [
  {
    id: Math.random() * 10,
    name: "Book_Code_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Voucher_Series",
        label: "Book Code ",
        masterName: "Voucher_Series",
        // dropdowndata: GetBookCodes,
        variable: {
          Voucher_Type: "Debit Note",
        },
        type: "InputDropForQuery",
      },
      {
        id: Math.random() * 10,
        name: "Bill_No",
        label: "Next Number",
        type: "Number",

        min: 5,
        max: 5,
      },
    ],
  },
];

export const DebitNoteInvoiceNumberConfig = [
  {
    id: Math.random() * 10,
    name: "Config_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Default_Voucher_Series",
        label: "Default Voucher Series",
        type: "InputDropForQuery",
        masterName: "Voucher_Series",
        variable: {
          Voucher_Type: "Debit Note",
        },
        min: 0,
        max: Infinity,
        isRequired: true,
      },
    ],
  },
];
